<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="action-row mx2">
	<div class="action-title">Notifications</div>
	<div fxFlex="1 0 0"></div>
	<mat-form-field [style.width.%]="'20'" [style.min-width.px]="'300'">
		<mat-label>Filter</mat-label>
		<input matInput [formControl]="notificationSearch" [disabled]="loading" />
		@if (notificationSearch.value) {
			<button matIconSuffix mat-icon-button aria-label="Clear" (click)="notificationSearch.setValue('')">
				<mat-icon>close</mat-icon>
			</button>
		}
	</mat-form-field>

	@if (isAdmin) {
		<button mat-raised-button color="primary" [disabled]="selectedRows.length === 0" (click)="deleteNotifications()">Delete</button>
	}
</div>

<cancom-table
	#grid
	fxFlex="1 0 0"
	[columnDefs]="columnsDef"
	[rowData]="rows"
	[rowSelection]="'multiple'"
	[pagination]="true"
	(selectionChanged)="selectionChanged($event)"
	[quickFilterText]="notificationSearchValue"
>
</cancom-table>
